import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';

export interface EffectiveStatusEntry {
  id: string;
  name: string;
}
export interface EffectiveStatusResponseEntry {
  ad: EffectiveStatusEntry[];
  adset: EffectiveStatusEntry[];
  campaign: EffectiveStatusEntry[];
}

export const getEffectiveStatuses = async (signal?: AbortSignal): Promise<EffectiveStatusResponseEntry> => {
  const res = await apiClient.get<{ meta: EffectiveStatusResponseEntry }>(`/effective_statuses`, {
    signal,
  });

  return res.data.meta;
};

interface UseEffectiveStatusesOptions<TData> {
  config?: QueryConfig<typeof getEffectiveStatuses, TData>;
}

export const useEffectiveStatuses = <TData = EffectiveStatusResponseEntry>({
  config,
}: UseEffectiveStatusesOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getEffectiveStatuses(signal),
    queryKey: ['effective-statuses'] as QueryKey,
  });
};
